import EmberObject from '@ember/object';

import PieWedge from './base-pie-wedge';

export default class BaseMain extends EmberObject {
  bigHugeCircuitGroupModel = null;

  getInterestingCircuits(commercialCircuit, toleranceInput) {
    var pieWedgeTable = [];
    var bigHugeCircuitGroup = this.bigHugeCircuitGroupModel.create({
      circuit: commercialCircuit,
      toleranceInput: toleranceInput,
    });
    pieWedgeTable.push(
      PieWedge.create({
        circuit: commercialCircuit,
        center: -180,
        range: 10,
        explanatoryText: 'low Q mid fp',
        bigHugeCircuitGroup: bigHugeCircuitGroup,
      }),
    );
    pieWedgeTable.push(
      PieWedge.create({
        circuit: commercialCircuit,
        center: -135,
        range: 20,
        explanatoryText: 'low Q low fp',
        bigHugeCircuitGroup: bigHugeCircuitGroup,
      }),
    );
    pieWedgeTable.push(
      PieWedge.create({
        circuit: commercialCircuit,
        center: -90,
        range: 10,
        explanatoryText: 'mid Q low fp',
        bigHugeCircuitGroup: bigHugeCircuitGroup,
      }),
    );
    pieWedgeTable.push(
      PieWedge.create({
        circuit: commercialCircuit,
        center: -45,
        range: 20,
        explanatoryText: 'high Q low fp',
        bigHugeCircuitGroup: bigHugeCircuitGroup,
      }),
    );
    pieWedgeTable.push(
      PieWedge.create({
        circuit: commercialCircuit,
        center: 0,
        range: 10,
        explanatoryText: 'high Q mid fp',
        bigHugeCircuitGroup: bigHugeCircuitGroup,
      }),
    );
    pieWedgeTable.push(
      PieWedge.create({
        circuit: commercialCircuit,
        center: 45,
        range: 20,
        explanatoryText: 'high Q high fp',
        bigHugeCircuitGroup: bigHugeCircuitGroup,
      }),
    );
    pieWedgeTable.push(
      PieWedge.create({
        circuit: commercialCircuit,
        center: 90,
        range: 10,
        explanatoryText: 'mid Q high fp',
        bigHugeCircuitGroup: bigHugeCircuitGroup,
      }),
    );
    pieWedgeTable.push(
      PieWedge.create({
        circuit: commercialCircuit,
        center: 135,
        range: 20,
        explanatoryText: 'low Q high fp',
        bigHugeCircuitGroup: bigHugeCircuitGroup,
      }),
    );

    var result = pieWedgeTable.map((pieWedge) => {
      return pieWedge.interestingCircuit;
    });
    return result;
  }

  createBigHugeCircuitGroup(commercialCircuit, toleranceInput) {
    return this.bigHugeCircuitGroupModel.create({ circuit: commercialCircuit, toleranceInput: toleranceInput });
  }

  getStageValuesFromCircuit(circuit) {
    return this.reverseImplementation.execute(circuit);
  }
}
